import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useUserSettings } from "../../context/userSettingsContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarPlateApi } from "../../http/carPlates/api";
import { UpsertCarPlate } from "../../http/carPlates/types";
import SvgAdd from "../icons/Add";
import Button from "../ui/Button";
import ModalDialog from "../ui/ModalDialog";
import CarPlateForm, { CarPlateFormBody } from "./CarPlateForm";

interface CreateCarPlateButtonProps {
  carId?: string;
  onSubmit?: () => void;
}

const CreateCarPlateButton: FC<CreateCarPlateButtonProps> = ({ carId, onSubmit }) => {
  const i18n = useI18n();
  const userSettings = useUserSettings();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const carPlatesApi = useCarPlateApi();

  const submit = async (formData: CarPlateFormBody) => {
    const body: UpsertCarPlate = {
      carId: carId ?? formData.car.id,
      nr: formData.nr,
      startDate: formData.startDate,
      endDate: formData.endDate,
    };

    setIsSubmitting(true);
    try {
      await carPlatesApi.insertAdminCarPlate(body);
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
      onSubmit?.();
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.carPlates.new}>
          <CarPlateForm
            isDisabled={!userSettings.permissions.carPlates.insert || isSubmitting}
            onSubmit={submit}
            allowSelectCar={!carId}
          />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateCarPlateButton;
